import { useState } from 'react'
import { useView } from '@10000/react'
import { uuid } from '@10000/common'
import { AddPill, Body, Box, Input, Avatar, ItemPill } from '../../widgets'
import { subscriptions } from '../../../lookups'
import { SettingsLayout } from '../'
import { Team } from './'

export const Teams = ({ superUserMode, goBackToSettingsMenu }) => {
  const { teams, subscription, user } = useView('tenant')
  const [search, setSearch] = useState('')
  const [selectedTeam, setSelectedTeam] = useState()
  const admin = superUserMode || user?.admin

  return selectedTeam === undefined
    ? <SettingsLayout
        gap={16}
        title="Teams"
        onBackButtonClick={goBackToSettingsMenu}
        backButtonMobileOnly
      >
        <Input dark leftIcon="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
        {teams.filter(team => !search || (team?.name || 'unnamed team').toLowerCase().includes(search.toLowerCase()))
          .map(({ name, avatar, id }, index) =>
            <ItemPill
              action={avatar === undefined}
              index={index}
              key={index}
              blackListBackgrounds={['white']}
              onClick={() => setSelectedTeam(id)}
            >
              <Box fullWidth alignItems="center" gap={8}>
                <Avatar size="small" index={avatar} mode="team"/>
                <Box fullWidth>
                  <Body bold align="left">{name ? name : 'Unnamed Team'}</Body>
                </Box>
                <Body underline alt bold size={12}>Edit</Body>
              </Box>
            </ItemPill>
          )
        }
        <Box column gap={16} fullWidth pb={16}>
          {((subscriptions[subscription.index]?.teamLimit || 0) > teams.length && admin) && (
            <AddPill text="Add new" onClick={() => setSelectedTeam(uuid())}/>
          )}
        </Box>
      </SettingsLayout>
    : <Team superUserMode={superUserMode} teamId={selectedTeam} onClose={() => setSelectedTeam(undefined)}/>
}